import React, { useEffect, useState } from 'react';
import API from '../../../api/axiosInstance';
import AddCaddieModal from '../AddCaddieModal';
import { clearCaddieOptionsCache, fetchCaddieOptions } from '../../../utils/caddieFormioUtils';
import { getAddCaddieConfig, toCaddieOption } from '../../../utils/addCaddieOption';

const API_URL = process.env.REACT_APP_API_URL || '';
const MAX_RESULTS = 8;
const MIN_ADD_CHARS = 2; // Same as Registration's Caddie Name dropdown.

/**
 * Registration's caddie search for the onsite form: search everyone in a Caddie group (any
 * competition); when nobody matches, add a new caddie to the active competition's Caddie group.
 * onPick receives the caddie. The form links them to the athlete on SUBMIT.
 */
const OnsiteCaddieSearch = ({ onPick }) => {
  const [options, setOptions] = useState([]);
  const [config, setConfig] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [query, setQuery] = useState('');
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      fetchCaddieOptions(),
      API.get('/ems/groups').then((res) => res.data).catch(() => []),
    ]).then(([caddies, groups]) => {
      if (cancelled) return;
      setOptions(caddies);
      setConfig(getAddCaddieConfig(groups));
      setLoaded(true);
    });
    return () => { cancelled = true; };
  }, []);

  const text = query.trim();
  const matches = text
    ? options.filter((c) =>
        [c.label, c.crm_label].some((name) => (name || '').toLowerCase().includes(text.toLowerCase()))
      )
    : [];
  const showEmpty = loaded && !!text && matches.length === 0;

  const pick = (caddie) => {
    onPick(caddie);
    setQuery('');
  };

  const handleCreated = (person) => {
    const caddie = toCaddieOption(person);
    setOptions((prev) => [...prev, caddie]);
    clearCaddieOptionsCache();
    setAdding(false);
    pick(caddie);
  };

  return (
    <div className="onsite-caddie-search">
      <label className="onsite-form-field__label" htmlFor="onsite-caddie-search">Find or add a caddie</label>
      <input
        id="onsite-caddie-search"
        className="onsite-form__input"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search caddie by name"
        autoComplete="off"
      />
      {(matches.length > 0 || showEmpty) && (
        <div className="onsite-caddie-search__results">
          {matches.slice(0, MAX_RESULTS).map((c) => (
            <button key={c._id} type="button" className="onsite-caddie-search__result" onClick={() => pick(c)}>
              <span>{c.label || '(unnamed)'}</span>
              {c.email && <span className="onsite-caddie-search__email">{c.email}</span>}
            </button>
          ))}
          {showEmpty && <p className="onsite-caddie-search__empty">No results found</p>}
          {showEmpty && config && text.length >= MIN_ADD_CHARS && (
            <button type="button" className="add-caddie-option__btn" onClick={() => setAdding(true)}>
              + Add &quot;{text}&quot; as a new caddie
            </button>
          )}
        </div>
      )}
      {adding && (
        <AddCaddieModal
          initialText={text}
          config={config}
          API_URL={API_URL}
          onClose={() => setAdding(false)}
          onCreated={handleCreated}
        />
      )}
    </div>
  );
};

export default OnsiteCaddieSearch;
